<template>
  <div>
		<section class="page-distribution-resource">
				<header-page
				name="distribution"
				:title="$route.meta.title"
				/>
				<v-layout pl-5 pt-3>
					<v-flex xs2 mt-3>
						<v-select
							box
							background-color="white"
							class="body-1"
							hide-details
							label="Planes"
							item-text="name"
							item-value="id"
							:items="plans"
							v-model="params.typePlan"
							@input="setParams({ model: 'typePlan', value: $event })"
						></v-select>
					</v-flex>
					<v-flex xs2 ml-3>
						<date-component
							label="Fecha Inicio"
							:date-formatted="params.startDate"
							:max-date="maxDate"
							model="startDate"
							@input="setParams({ model: 'startDate', value: $event })"
						/>
					</v-flex>
					<v-flex xs2 ml-3>
						<date-component
							label="Fecha Final"
							:date-formatted="params.endDate"
							:max-date="maxDate"
							:readonly="!params.startDate"
							model="endDate"
							:min-date="params.startDate"
							@input="setParams({ model: 'endDate', value: $event })"
						/>
					</v-flex>
					<v-btn class="sales-btn ml-3 mt-4" outlined color="primary" elevation="2" @click="listDistribution">
						<v-icon>search</v-icon>
					</v-btn>
					<v-layout justify-end class="mr-5">
						<v-btn class="sales-btn ml-3 mt-4" outlined color="red" elevation="2" @click="cleanFilter">
							<span class="white-text">Limpiar filtros</span>					
						</v-btn>
					</v-layout>
				</v-layout>
				<div class="px-5">
					<app-table
					:columns="columns"
					:check-all="checkAll"
					:selected-value="selectedValue"
					selectable
					class="mt-5"
					:rows="rows"
					:check-row="checkRow"
					:current-page="currentPage"
					:last-page="lastPage"
					@on-search-event="onSearch"
					@on-page="changePage"
					@row-is-selected="rowIsSelected"
					@on-selected-all="allIsSelected"
					>
					<template slot="rows" slot-scope="props">
						<td>{{props.row.razonSocial}}</td>
						<td>{{ props.row.codeCompany }}</td>
						<td>{{props.row.ruc}}</td>
						<td>{{props.row.planName}}</td>
						<td>{{props.row.country ? props.row.country.data.name : ''}}</td>
						<td>
							<div class="d-flex align-center">
								<app-tooltip-button
									:color="props.row.flagSyncTemplate === 0 ? 'cyan': 'yellow' "
									icon="sync"
									:text="props.row.flagSyncTemplate === 0 ? 'Sincronizado' : 'Pendiente'"
								/>
								<app-tooltip-button
									color="green"
									icon="store"
									text="Personalización a la empresa"
									@click-icon="openConfirmDialog(props.row)"
								/>
								<app-tooltip-button
									color="primary"
									icon="paid"
									text="Visualizar ventas"
									@click-icon="openSales(props.row)"
								/>
								<app-tooltip-button
									color="blue"
									icon="people_outline"
									text="Usuarios por compañia"
									@click-icon="goToUser(props.row)"
								/>
								<v-tooltip top>
									<v-switch
										slot="activator"
										color="green"
										class="mt-0 ml-2"
										hide-details
										v-model="props.row.flagBlocked"
										@change="blockedCompany(props.row)"
									></v-switch>
									<span class="text-center">{{ props.row.flagBlocked ? 'Desbloquear' : 'Bloquear' }} compañía</span>
								</v-tooltip>
							</div>
						</td>
						</template>
					</app-table>
					<v-dialog v-model="dialog" persistent max-width="500">
						<v-card>
							<v-card-title class="subheading">{{ dialogMessage }}</v-card-title>
								<v-card-actions class="justify-center">
								<v-btn
									class="btn-action"
									color="green"
									dark
									@click.native="postDistribution"
									:disabled="loading"
								>
									SI
								</v-btn>
								<v-btn
									class="btn-action"
									color="error"
									dark
									@click.native="close"
								>
									NO
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</div>
				<v-card-actions class="justify-center mt-5">
					<v-btn
					class="btn-action caption mr-1"
					color="primary"
					@click="returnDistribution"
					>
						Cancelar
					</v-btn>
					<v-btn
						class="btn-action caption mr-1"
						color="green"
						@click="updateDistribution"
					>
						Distribuir
					</v-btn>
				</v-card-actions>
				<action-sidebar
					:title="action.title"
					:width="action.width"
					:value="action.value"
					@close-modal="closeModal"
				>
					<company-sales
						v-if="action.code === 'VIS'"
						:row-template="dataTemplate"
						:templates="templates"
						:id-distribution="idDistribution"
						@close-modal="closeModal"
					/>
				</action-sidebar>
		</section>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import dateComponent from '@/components/shared/date-component';
import companySales from '@/components/companies/company-sales';
import actionSidebar from '@/components/shared/action-sidebar';
import actionBar from '@/components/shared/action-bar';
import { format } from 'date-fns';

async function updateDistribution() {
	const newArrayDistribution = this.dataSelected.map(item => item.id);
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	const body = {
		companiesId: newArrayDistribution,
	};
	const url = `project/${this.codeProject}/distribution/${this.idDistribution}`;
	try {
		await this.$http.patch(url, body, { headers });
		this.showNotification('Se ha distribuido los recursos');
	} catch (error) {
		console.log(error);
		if (error.status === 405) {
			if (error.data.message === "TEMPLATE_HAVEN'T_ASSOCIATED_DATA") {
				this.showNotification('Plantilla no tiene datos asociados');
			}
		}
	}
}

async function postDistribution() {
	this.loading = true;
	try {
		await this.$http.post(`template/${this.idDistribution}/companies/${this.rowId}`);
		this.showNotification(`Se ha generado una nueva plantilla relacionada a su compañia ${this.nameCompany}`);
		this.close();
		this.listDistribution();
	} catch (error) {
		console.log(error);
		this.showError();
	} finally {
		this.loading = false;
	}
}

function openConfirmDialog({ id, razonSocial }) {
	this.nameCompany = razonSocial;
	this.rowId = id;
	this.dialogMessage = `¿Desea hacerle una personalización a la empresa '${razonSocial}'?`;
	this.dialog = true;
}

function close() {
	this.dialog = false;
}

async function created() {
	this.listDistribution();
	this.loadPlans();
	const response = await this.$http.get(`project/${this.codeProject}/template`);
	this.templates = response.data.data;
}

async function listDistribution() {
	const params = {
		...this.params,
	};
	try {
		const response = await this.$http.get(`template/${this.idDistribution}/companies`, { params });
		this.lastPage = Number(response.headers['x-last-page']);
		this.rows = response.data.data.map((r) => {
			const newRow = { ...r };
			newRow.isSelected = false;
			const plan = this.plans.find((p) => p.id === r.typePlan);
			newRow.planName = plan ? plan.name : '-';
			return newRow;
		});
		this.checkAll = this.rows.every(r => r.isSelected);
		// this.dataSelected = this.rows;
	} catch (error) {
		console.log(error);
		this.showError();
	}
}

function returnDistribution() {
	this.goTo('page-template');
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.listDistribution();
}

function onSearch(value) {
	this.params.search = value;
	this.listDistribution();
}

function rowIsSelected(row) {
	this.rows = this.selectIsRow(this.rows, this.selectedValue, row);
	this.checkAll = this.every(this.rows, this.selectedValue);
	this.setDataSelected(row);
}

function setDataSelected(row) {
	if (!row) {
		if (this.checkAll) {
			this.table.rows.forEach((rowData) => {
				const index = this.dataSelected.finIndex(d => d.id === rowData.id);
				if (index < 0) {
					this.dataSelected.push(rowData);
				}
			});
		} else {
			this.table.rows.forEach((rowData) => {
				const index = this.dataSelected.finIndex(d => d.id === rowData.id);
				if (index >= 0) {
					this.dataSelected.splice(index, 1);
				}
			});
		}
	} else {
		const index = this.dataSelected.findIndex(d => d.id === row.id);
		if (index < 0) {
			this.dataSelected.push(row);
		} else {
			this.dataSelected.splice(index, 1);
		}
	}
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.rows = this.selectIsRow(this.rows, this.selectedValue, false, checked);
	this.dataSelected = checked ? this.rows : [];
}

function goToUser({ codeCompany }) {
	this.goTo('page-user', { params: { codeProject: this.codeProject, idCompany: codeCompany } });
}

function data() {
	return {
		action: {
			title: '',
			code: '',
			width: 0,
			value: false,
		},
		dataTemplate: null,
		dataSelected: [],
		loading: false,
		checkAll: false,
		checkRow: false,
		companiesId: '',
		selectedValue: 'isSelected',
		dialogMessage: '',
		dialog: false,
		codeApp: '',
		currentPage: 1,
		lastPage: 0,
		rows: [],
		columns: [
			{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 2, name: 'Código Compañía', value: 'code', checked: true, visible: true },
			{ id: 3, name: 'RUC', value: 'ruc', checked: true, visible: true },
			{ id: 4, name: 'Plan', value: 'planName', checked: true, visible: true },
			{ id: 5, name: 'Pais', value: 'state', checked: true, visible: true },
			{ id: 6, name: 'Acciones', value: 'action', checked: true, visible: true },
		],
		params: {
			typePlan: null,
			startDate: null,
			endDate: null,
			page: 1,
			perPage: 30,
		},
		plans: [],
		templates: [],
		maxDate: new Date().toISOString().split('T')[0],
	};
}

export default {
	name: 'page-distribution-of-resources',
	created,
	data,
	components: {
		appTooltipButton,
		dateComponent,
		actionBar,
		actionSidebar,
		companySales,
	},
	methods: {
		updateDistribution,
		postDistribution,
		close,
		goToUser,
		onSearch,
		openConfirmDialog,
		rowIsSelected,
		allIsSelected,
		changePage,
		returnDistribution,
		setDataSelected,
		listDistribution,
		async openSales(row) {
			this.action = {
				code: 'VIS',
				title: 'Visualizar informacion de ventas',
				width: 700,
				value: true,
			};
			this.dataTemplate = row;
		},
		closeModal() {
			this.action.value = false;
			this.action.title = '';
			this.action.code = '';
			this.action.width = 0;
			this.allIsSelected(false);
		},
		async loadPlans() {
			const response = await this.$http.get('type-plans');
			this.plans = response.data.data;
		},
		setParams({ model, value }) {
			if (model === 'typePlan') {
				this.params[model] = value;
			} else {
				this.params[model] = format(value.value, 'YYYY-MM-DD');
			}
		},
		async blockedCompany(row) {
			const { flagBlocked, id, nombreComercial } = row;
			const message = flagBlocked ? 'bloqueo' : 'desbloqueo';
			const body = {
				flagBlocked: flagBlocked ? 1 : 0,
			};
			try {
				await this.$http.patch(`company/${id}/blocked`, body);
				this.showNotification(`Se ${message} la compañía ${nombreComercial} correctamente`);
			} catch (error) {
				this.showNotification('No se pudo bloquear la compañía', 'error');
			}
		},
		cleanFilter() {
			this.params = {
				typePlan: null,
				startDate: null,
				endDate: null,
				page: 1,
				perPage: 30,
			};
			this.listDistribution();
		},
	},
	props: {
		idDistribution: [Number, String],
		codeProject: String,
		codeTemplate: [Number, String],
	},
};
</script>
<style>
.sales-btn {
  padding: 8px 16px;
  text-transform: none;
  font-weight: bold;
}

.white-text {
    color: white;
}

</style>


// WEBPACK FOOTER //
// src/pages/template/page-distribution-of-resources.vue